// extracted by mini-css-extract-plugin
export default {"fake-button":"le4-2","fakeButton":"le4-2"};